import * as _ from "lodash";

// Error codes from backend service
export type ErrorCode =
    "UNKNOWN" |
    "HASH_MISMATCH" |

    "OTP_INVALID" |
    "OTP_EXPIRED" |

    "TAC_INVALID" |
    "TAC_EXPIRED" |

    "CARDTAN_INVALID" |

    "ONE_ATTEMPT_LEFT" |
    "TAC_LIMIT_EXCEEDED" |
    "FIELD_TOO_SHORT" |
    "FIELD_INVALID" |
    "USER_LOCKED" |
    "FIELD_TOO_LONG" |
    "SID_REJECTED" |
    "SID_EXPIRED" |
    "GEORGE_TOKEN_REJECTED" |
    "GEORGE_TOKEN_EXPIRED" |

    "AMOUNT_EXCEED_LIMITS" |
    "BAD_REQUEST" |
    "NOT_POSSIBLE" |
    "OPEN_PENDING_REQUEST" |

    "INVALID_CLOSE_REASON" |
    "FIELD_MISSING" |
    "ACCOUNT_INVALID" |
    "CARD_BALANCE_LIMIT" |
    "INVALID_CARD_STATE" |
    "CARD_NOT_EXIST" |
    "CARD_NOT_RELOADABLE" |
    "CARD_LOCKED" |
    "CARD_CLOSED"
    ;

export interface IApiError {
    scope: string;
    error: ErrorCode;
    message?: string;
}

export function hasError(networkError: any, error: IApiError): boolean {
    const response = networkError.response;
    if (!response) {
        return false;
    }

    const errors = response.errors;
    if (!errors || !errors.length || errors.length === 0) {
        return false;
    }

    return _.find(errors, error) !== undefined;
}

export function getErrorWithCode(networkError: any, code: ErrorCode): IApiError | undefined {
    const response = networkError.response;
    if (!response) {
        return undefined;
    }

    const errors = response.errors;
    if (!errors || !errors.length || errors.length === 0) {
        return undefined;
    }

    return _.find(errors, error => error.error === code);
}

export function hasErrorWithCode(networkError: any, code: ErrorCode): boolean {
    return getErrorWithCode(networkError, code) !== undefined;
}


// WEBPACK FOOTER //
// ./src/types/error.ts